<template>
  <div>
    <div class="panelRow">
      <div>
        <span style="color: red">*</span>
        {{ i18n['label'] }}：
      </div>
      <!-- @input="(value) => {onChange('label', value)}" -->
      <a-input
        :disabled="readOnly"
        :value="model.label"
        @input="(event) => {onChange('label',  event.currentTarget.value)}"
        style="width:90%; font-size:12px"
      />
    </div>
    <div class="panelRow">
      <div>
        <span style="color: red">*</span> 顺序：
      </div>
      <a-input
        :disabled="readOnly"
        :value="model.sort"
        @input="(event) => {onChange('sort', event.currentTarget.value)}"
        style="width:90%; font-size:12px"
      />
    </div>
    <div class="panelRow">
      <a-checkbox
        :checked="!!model.isHideNode"
        :disabled="readOnly"
        @input="(value)=>{onChange('isHideNode',value)}"
      >隐藏节点</a-checkbox>
      <a-checkbox :checked="!!model.hideIcon" :disabled="readOnly" @input="(value)=>{onChange('hideIcon',value)}">隐藏图标</a-checkbox>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'DefaultDetail',
    inject: ['i18n'],
    props: {
      model: {
        type: Object,
        default: () => ({})
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      change (event, attr) {
        this.onChange(attr, event.target.checked)
      }
    }
  }
</script>
